import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "@copro/api";
import type { Database } from "@copro/api";
import { enqueueSnackbar } from "../../../components/GlobalSnackbar/snackbarStore";
import { keys } from "./keys";

type UpdateCommand = Database['public']['Tables']['sub_topics']['Update'];

async function updateSubTopic(id: string, command: UpdateCommand) {
  const { error } = await apiClient
    .from('sub_topics')
    .update(command)
    .eq('id', id);

  if (error) {
    throw error;
  }
}

export function useUpdateSubTopic() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, command }: { id: string; command: UpdateCommand }) =>
      updateSubTopic(id, command),
    onSuccess: (_data, variables) => {
      enqueueSnackbar('Sous-sujet mis à jour.', 'success');
      queryClient.invalidateQueries({ queryKey: keys.subTopicList() });
      if (variables?.id) {
        queryClient.invalidateQueries({ queryKey: keys.subTopic(variables.id) });
      }
      queryClient.invalidateQueries({ queryKey: ['calendar'] });
    }
  });
}
